import { DragDropModule } from "@angular/cdk/drag-drop";
import { CommonModule, NgOptimizedImage } from "@angular/common";
import { NgModule } from "@angular/core";
import { FormsModule, ReactiveFormsModule } from "@angular/forms";
import { HammerModule } from "@angular/platform-browser";
import { RouterModule } from "@angular/router";
import { NgxSliderModule } from "@angular-slider/ngx-slider";
import { PickerModule } from "@ctrl/ngx-emoji-mart";
import { NgWizardModule } from "@kronscht/ng-wizard";
import {
  NgbAccordionModule,
  NgbCarouselModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbModalConfig,
  NgbModalModule,
  NgbNavModule,
  NgbOffcanvasModule,
  NgbPaginationModule,
  NgbPopoverModule,
  NgbProgressbarModule,
  NgbTooltipModule
} from "@ng-bootstrap/ng-bootstrap";
import { NgSelectModule } from "@ng-select/ng-select";
import { FormlyBootstrapModule } from "@ngx-formly/bootstrap";
import { FormlyModule } from "@ngx-formly/core";
import { FormlySelectModule } from "@ngx-formly/core/select";
import { TranslateModule } from "@ngx-translate/core";
import { AccessoryEditorComponent } from "@shared/components/equipment/editors/accessory-editor/accessory-editor.component";
import { BaseItemEditorComponent } from "@shared/components/equipment/editors/base-item-editor/base-item-editor.component";
import { BrandEditorCardComponent } from "@shared/components/equipment/editors/brand-editor-card/brand-editor-card.component";
import { BrandEditorFormComponent } from "@shared/components/equipment/editors/brand-editor-form/brand-editor-form.component";
import { CameraEditorComponent } from "@shared/components/equipment/editors/camera-editor/camera-editor.component";
import { ConfirmItemCreationModalComponent } from "@shared/components/equipment/editors/confirm-item-creation-modal/confirm-item-creation-modal.component";
import { FilterEditorComponent } from "@shared/components/equipment/editors/filter-editor/filter-editor.component";
import { MountEditorComponent } from "@shared/components/equipment/editors/mount-editor/mount-editor.component";
import { OthersInBrandComponent } from "@shared/components/equipment/editors/others-in-brand/others-in-brand.component";
import { SensorEditorComponent } from "@shared/components/equipment/editors/sensor-editor/sensor-editor.component";
import { SoftwareEditorComponent } from "@shared/components/equipment/editors/software-editor/software-editor.component";
import { TelescopeEditorComponent } from "@shared/components/equipment/editors/telescope-editor/telescope-editor.component";
import { EquipmentFollowOptionsComponent } from "@shared/components/equipment/equipment-follow-options/equipment-follow-options.component";
import { EquipmentFollowOptionsModalComponent } from "@shared/components/equipment/equipment-follow-options-modal/equipment-follow-options-modal.component";
import { EquipmentItemDisplayNameComponent } from "@shared/components/equipment/equipment-item-display-name/equipment-item-display-name.component";
import { ItemBrowserComponent } from "@shared/components/equipment/item-browser/item-browser.component";
import { VariantSelectorModalComponent } from "@shared/components/equipment/item-browser/variant-selector-modal/variant-selector-modal.component";
import { ItemBrowserByPropertiesComponent } from "@shared/components/equipment/item-browser-by-properties/item-browser-by-properties.component";
import { ItemUnapprovedInfoModalComponent } from "@shared/components/equipment/item-unapproved-info-modal/item-unapproved-info-modal.component";
import { MarketplaceListingCardComponent } from "@shared/components/equipment/marketplace-listing-card/marketplace-listing-card.component";
import { MarketplaceListingCardsComponent } from "@shared/components/equipment/marketplace-listing-cards/marketplace-listing-cards.component";
import { RemoveRecentlyUsedEquipmentModalComponent } from "@shared/components/equipment/modals/remove-recently-used-equipment-modal/remove-recently-used-equipment-modal.component";
import { EquipmentPresetComponent } from "@shared/components/equipment/preset/equipment-preset.component";
import { EquipmentPresetEditorComponent } from "@shared/components/equipment/preset-editor/equipment-preset-editor.component";
import { EquipmentPresetSummaryComponent } from "@shared/components/equipment/preset-summary/equipment-preset-summary.component";
import { SimilarItemsSuggestionComponent } from "@shared/components/equipment/similar-items-suggestion/similar-items-suggestion.component";
import { StockStatusComponent } from "@shared/components/equipment/stock-status/stock-status.component";
import { AssignEditProposalModalComponent } from "@shared/components/equipment/summaries/assign-edit-proposal-modal/assign-edit-proposal-modal.component";
import { AssignItemModalComponent } from "@shared/components/equipment/summaries/assign-item-modal/assign-item-modal.component";
import { BrandSummaryComponent } from "@shared/components/equipment/summaries/brand-summary/brand-summary.component";
import { MostOftenUsedWithModalComponent } from "@shared/components/equipment/summaries/item/summary/most-often-used-with-modal/most-often-used-with-modal.component";
import { ItemSummaryComponent } from "@shared/components/equipment/summaries/item-summary/item-summary.component";
import { ProgressiveDisclosureGroupSelectComponent } from "@shared/components/fields/progressive-disclosure-group-select/progressive-disclosure-group-select.component";
import { MobileFooterComponent } from "@shared/components/footer/mobile-footer.component";
import { ForumPreviewComponent } from "@shared/components/forums/forum-preview/forum-preview.component";
import { MobileHeaderComponent } from "@shared/components/header/mobile-header.component";
import { ImageGalleryLoadingComponent } from "@shared/components/image-gallery-loading-indicator/image-gallery-loading.component";
import { MasonryLayoutComponent } from "@shared/components/masonry-layout/masonry-layout.component";
import { AdManagerComponent } from "@shared/components/misc/ad-manager/ad-manager.component";
import { AnnotationToolModule } from "@shared/components/misc/annotation-tool/annotation-tool.module";
import { AvatarComponent } from "@shared/components/misc/avatar/avatar.component";
import { AvatarEditorComponent } from "@shared/components/misc/avatar-editor/avatar-editor.component";
import { AvatarManagerComponent } from "@shared/components/misc/avatar-manager/avatar-manager.component";
import { CameraComponent } from "@shared/components/misc/camera/camera.component";
import { CollectionImageCountComponent } from "@shared/components/misc/collection-image-count/collection-image-count.component";
import { ConfirmationDialogComponent } from "@shared/components/misc/confirmation-dialog/confirmation-dialog.component";
import { CoordinatesDisplayComponent } from "@shared/components/misc/coordinates-display/coordinates-display.component";
import { CountDownComponent } from "@shared/components/misc/count-down/count-down.component";
import { CountrySelectionModalComponent } from "@shared/components/misc/country-selection-modal/country-selection-modal.component";
import { CustomToastComponent } from "@shared/components/misc/custom-toast/custom-toast.component";
import { DataDoesNotUpdateInRealTimeComponent } from "@shared/components/misc/data-does-not-update-in-real-time/data-does-not-update-in-real-time.component";
import { DescriptionModalWrapperComponent } from "@shared/components/misc/description-modal-wrapper/description-modal-wrapper.component";
import { FloatingPresentationButtonComponent } from "@shared/components/misc/floating-presentation-button/floating-presentation-button.component";
import { FormlyCardWrapperComponent } from "@shared/components/misc/formly-card-wrapper/formly-card-wrapper.component";
import { FormlyEquipmentItemBrowserWrapperComponent } from "@shared/components/misc/formly-equipment-item-browser-wrapper/formly-equipment-item-browser-wrapper.component";
import { FormlyFieldArrayComponent } from "@shared/components/misc/formly-field-array/formly-field-array.component";
import { FormlyFieldButtonComponent } from "@shared/components/misc/formly-field-button/formly-field-button.component";
import { DragDropAreaComponent } from "@shared/components/misc/formly-field-chunked-file/drag-drop-area.component";
import { FormlyFieldChunkedFileComponent } from "@shared/components/misc/formly-field-chunked-file/formly-field-chunked-file.component";
import { FormlyFieldCKEditorComponent } from "@shared/components/misc/formly-field-ckeditor/formly-field-ckeditor.component";
import { FormlyFieldColorPickerComponent } from "@shared/components/misc/formly-field-color-picker/formly-field-color-picker.component";
import { FormlyFieldCustomNumberComponent } from "@shared/components/misc/formly-field-custom-number/formly-field-custom-number.component";
import { FormlyFieldCustomRadioComponent } from "@shared/components/misc/formly-field-custom-radio/formly-field-custom-radio.component";
import { FormlyFieldEquipmentItemBrowserComponent } from "@shared/components/misc/formly-field-equipment-item-browser/formly-field-equipment-item-browser.component";
import { FileValueAccessorDirective } from "@shared/components/misc/formly-field-file/file-value-accessor.directive";
import { FormlyFieldFileComponent } from "@shared/components/misc/formly-field-file/formly-field-file.component";
import { FormlyFieldGoogleMapComponent } from "@shared/components/misc/formly-field-google-map/formly-field-google-map.component";
import { FormlyFieldImageCropperComponent } from "@shared/components/misc/formly-field-image-cropper/formly-field-image-cropper.component";
import { FormlyFieldNgSelectComponent } from "@shared/components/misc/formly-field-ng-select/formly-field-ng-select.component";
import { FormlyFieldSliderComponent } from "@shared/components/misc/formly-field-slider/formly-field-slider.component";
import { FormlyFieldStepperComponent } from "@shared/components/misc/formly-field-stepper/formly-field-stepper.component";
import { FormlyFieldTableComponent } from "@shared/components/misc/formly-field-table/formly-field-table.component";
import { FormlyFieldTagsWithAiComponent } from "@shared/components/misc/formly-field-tags-with-ai/formly-field-tags-with-ai.component";
import { FormlyFieldTiptapComponent } from "@shared/components/misc/formly-field-tiptap/formly-field-tiptap.component";
import { TiptapGalleryImageSelectorComponent } from "@shared/components/misc/formly-field-tiptap/tiptap-gallery-image-selector/tiptap-gallery-image-selector.component";
import { FormlyFieldTitleWithAiComponent } from "@shared/components/misc/formly-field-title-with-ai/formly-field-title-with-ai.component";
import { FormlyFieldToggleComponent } from "@shared/components/misc/formly-field-toggle/formly-field-toggle.component";
import { FormlyFieldTurnstileComponent } from "@shared/components/misc/formly-field-turnstile/formly-field-turnstile.component";
import { FormlyWrapperComponent } from "@shared/components/misc/formly-wrapper/formly-wrapper.component";
import { FullscreenImageViewerComponent } from "@shared/components/misc/fullscreen-image-viewer/fullscreen-image-viewer.component";
import { HrComponent } from "@shared/components/misc/hr/hr.component";
import { ImageComponent } from "@shared/components/misc/image/image.component";
import { ImageHoverComponent } from "@shared/components/misc/image-hover/image-hover.component";
import { ImageIconsComponent } from "@shared/components/misc/image-icons/image-icons.component";
import { ImageLoadingIndicatorComponent } from "@shared/components/misc/image-loading-indicator/image-loading-indicator.component";
import { ImageViewerAcquisitionCsvExportComponent } from "@shared/components/misc/image-viewer/image-viewer-acquisition-csv-export.component";
import { ImageViewerAcquisitionDatesComponent } from "@shared/components/misc/image-viewer/image-viewer-acquisition-dates.component";
import { ImageViewerAcquisitionComponent } from "@shared/components/misc/image-viewer/image-viewer-acquisition.component";
import { ImageViewerAdditionalButtonComponent } from "@shared/components/misc/image-viewer/image-viewer-additional-buttons.component";
import { ImageViewerAdjustmentsEditorComponent } from "@shared/components/misc/image-viewer/image-viewer-adjustments-editor.component";
import { ImageViewerAstrometryComponent } from "@shared/components/misc/image-viewer/image-viewer-astrometry.component";
import { ImageViewerCloseButtonComponent } from "@shared/components/misc/image-viewer/image-viewer-close-button.component";
import { ImageViewerCustomMessageBannerComponent } from "@shared/components/misc/image-viewer/image-viewer-custom-message-banner.component";
import { ImageViewerDataSourceComponent } from "@shared/components/misc/image-viewer/image-viewer-data-source.component";
import { ImageViewerEquipmentItemsComponent } from "@shared/components/misc/image-viewer/image-viewer-equipment-items.component";
import { ImageViewerEquipmentComponent } from "@shared/components/misc/image-viewer/image-viewer-equipment.component";
import { ImageViewerFloatingTitleComponent } from "@shared/components/misc/image-viewer/image-viewer-floating-title.component";
import { ImageViewerGroupsAndCollectionsComponent } from "@shared/components/misc/image-viewer/image-viewer-groups-and-collections.component";
import { ImageViewerGuidingEquipmentComponent } from "@shared/components/misc/image-viewer/image-viewer-guiding-equipment.component";
import { ImageViewerIotdBannerComponent } from "@shared/components/misc/image-viewer/image-viewer-iotd-banner.component";
import { ImageViewerIotdTpStatsComponent } from "@shared/components/misc/image-viewer/image-viewer-iotd-tp-stats.component";
import { ImageViewerMenuComponent } from "@shared/components/misc/image-viewer/image-viewer-menu.component";
import { ImageViewerObjectsComponent } from "@shared/components/misc/image-viewer/image-viewer-objects.component";
import { ImageViewerPhotographersComponent } from "@shared/components/misc/image-viewer/image-viewer-photographers.component";
import { ImageViewerPlateSolvingBannerComponent } from "@shared/components/misc/image-viewer/image-viewer-plate-solving-banner.component";
import { ImageViewerRevisionSummaryComponent } from "@shared/components/misc/image-viewer/image-viewer-revision-summary.component";
import { ImageViewerRevisionsComponent } from "@shared/components/misc/image-viewer/image-viewer-revisions.component";
import { ImageViewerShareButtonComponent } from "@shared/components/misc/image-viewer/image-viewer-share-button.component";
import { ImageViewerSocialButtonsComponent } from "@shared/components/misc/image-viewer/image-viewer-social-buttons.component";
import { ImageViewerTitleComponent } from "@shared/components/misc/image-viewer/image-viewer-title.component";
import { ImageViewerWipBannerComponent } from "@shared/components/misc/image-viewer/image-viewer-wip-banner.component";
import { ImageViewerComponent } from "@shared/components/misc/image-viewer/image-viewer.component";
import { ImageViewerSlideshowContextComponent } from "@shared/components/misc/image-viewer-slideshow/image-viewer-slideshow-context.component";
import { ImageViewerSlideshowComponent } from "@shared/components/misc/image-viewer-slideshow/image-viewer-slideshow.component";
import { PresentationModeModule } from "@shared/components/misc/image-viewer-slideshow/presentation-mode/presentation-mode.module";
import { InformationDialogComponent } from "@shared/components/misc/information-dialog/information-dialog.component";
import { LoadingDialogComponent } from "@shared/components/misc/loading-dialog/loading-dialog.component";
import { LoadingIndicatorComponent } from "@shared/components/misc/loading-indicator/loading-indicator.component";
import { MeasuringToolModule } from "@shared/components/misc/measuring-tool/measuring-tool.module";
import { NestedCommentComponent } from "@shared/components/misc/nested-comments/nested-comment.component";
import { NestedCommentsComponent } from "@shared/components/misc/nested-comments/nested-comments.component";
import { NestedCommentsCountComponent } from "@shared/components/misc/nested-comments-count/nested-comments-count.component";
import { NestedCommentsModalComponent } from "@shared/components/misc/nested-comments-modal/nested-comments-modal.component";
import { NothingHereComponent } from "@shared/components/misc/nothing-here/nothing-here.component";
import { NotificationsListComponent } from "@shared/components/misc/notifications-list/notifications-list.component";
import { PostEquipmentHeaderComponent } from "@shared/components/misc/post-equipment-header/post-equipment-header.component";
import { PostQualityIndicatorPillComponent } from "@shared/components/misc/post-quality-indicator-pill/post-quality-indicator-pill.component";
import { PrivateInformationComponent } from "@shared/components/misc/private-information/private-information.component";
import { RefreshButtonComponent } from "@shared/components/misc/refresh-button/refresh-button.component";
import { RemoveAdsDialogComponent } from "@shared/components/misc/remove-ads-dialog/remove-ads-dialog.component";
import { ScrollToTopComponent } from "@shared/components/misc/scroll-to-top/scroll-to-top.component";
import { SubscriptionRequiredModalComponent } from "@shared/components/misc/subscription-required-modal/subscription-required-modal.component";
import { SwipeToRefreshComponent } from "@shared/components/misc/swipe-to-refresh/swipe-to-refresh.component";
import { TelescopeComponent } from "@shared/components/misc/telescope/telescope.component";
import { TextLoadingIndicatorComponent } from "@shared/components/misc/text-loading-indicator/text-loading-indicator.component";
import { ToggleButtonComponent } from "@shared/components/misc/toggle-button/toggle-button.component";
import { TogglePropertyComponent } from "@shared/components/misc/toggle-property/toggle-property.component";
import { TutorialModule } from "@shared/components/misc/tutorial/tutorial.module";
import { UpgradeNudgeComponent } from "@shared/components/misc/upgrade-nudge/upgrade-nudge.component";
import { UpgradePricingModalComponent } from "@shared/components/misc/upgrade-pricing-modal/upgrade-pricing-modal.component";
import { UserPostQualityIndicatorsComponent } from "@shared/components/misc/user-post-quality-indicators/user-post-quality-indicators.component";
import { UsernameService } from "@shared/components/misc/username/username.service";
import { ReportAbuseModalComponent } from "@shared/components/report-abuse-modal/report-abuse-modal.component";
import { ForumPostSearchComponent } from "@shared/components/search/forum-post-search/forum-post-search.component";
import {
  ImageSearchBrandListingMessagePipe,
  ImageSearchComponent,
  ImageSearchItemListingMessagePipe
} from "@shared/components/search/image-search/image-search.component";
import { ImageSearchCardComponent } from "@shared/components/search/image-search-card/image-search-card.component";
import { NestedCommentSearchComponent } from "@shared/components/search/nestedcomment-search/nested-comment-search.component";
import { UserSearchComponent } from "@shared/components/search/user-search/user-search.component";
import { DirectivesModule } from "@shared/directives/directives.module";
import { IconsModule } from "@shared/icons.module";
import { PipesModule } from "@shared/pipes/pipes.module";
import { NgxDatatableModule } from "@swimlane/ngx-datatable";
import { NgToggleModule } from "ng-toggle-button";
import { AutoSizeInputModule } from "ngx-autosize-input";
import { NgxFilesizeModule } from "ngx-filesize";
import { ImageCropperModule } from "ngx-image-cropper";
import { NgxImageZoomModule } from "ngx-image-zoom";
import { LightboxModule } from "ngx-lightbox";
import { TimeagoModule } from "ngx-timeago";
import { UploadxModule } from "ngx-uploadx";

import { LoginFormComponent } from "./auth/login-form/login-form.component";
import { LoginModalComponent } from "./auth/login-modal/login-modal.component";
import { OtpInputComponent } from "./auth/otp-input/otp-input.component";
import { SessionTimeoutTimerComponent } from "./auth/session-timeout-timer/session-timeout-timer.component";
import { TwoFactorFormComponent } from "./auth/two-factor-form/two-factor-form.component";
import { SparklesIconComponent } from "./icons/sparkles-icon/sparkles-icon.component";
import { EmptyListComponent } from "./misc/empty-list/empty-list.component";
import { ReadOnlyModeComponent } from "./misc/read-only-mode/read-only-mode.component";
import { TurnstileCaptchaComponent } from "./misc/turnstile-captcha/turnstile-captcha.component";
import { UsernameComponent } from "./misc/username/username.component";

const modules = [
  CommonModule,
  DirectivesModule,
  DragDropModule,
  FormsModule,
  FormlyBootstrapModule,
  FormlySelectModule,
  HammerModule,
  ImageCropperModule,
  LightboxModule,
  MeasuringToolModule,
  AnnotationToolModule,
  PresentationModeModule,
  TutorialModule,
  NgbAccordionModule,
  NgbCarouselModule,
  NgbCollapseModule,
  NgbDropdownModule,
  NgbNavModule,
  NgbModalModule,
  NgbOffcanvasModule,
  NgbPaginationModule,
  NgbPopoverModule,
  NgbProgressbarModule,
  NgbTooltipModule,
  NgSelectModule,
  NgToggleModule,
  NgxFilesizeModule,
  NgxDatatableModule,
  NgxImageZoomModule,
  NgxSliderModule,
  NgWizardModule,
  PipesModule,
  ReactiveFormsModule,
  RouterModule,
  TimeagoModule,
  TranslateModule,
  FormlyModule,
  UploadxModule,
  AutoSizeInputModule,
  NgOptimizedImage,
  IconsModule,
  PickerModule
];

const components = [
  AdManagerComponent,
  AvatarComponent,
  AvatarEditorComponent,
  AvatarManagerComponent,
  CameraComponent,
  CollectionImageCountComponent,
  ConfirmationDialogComponent,
  CountDownComponent,
  CountrySelectionModalComponent,
  CustomToastComponent,
  DataDoesNotUpdateInRealTimeComponent,
  UpgradeNudgeComponent,
  UpgradePricingModalComponent,
  CoordinatesDisplayComponent,
  DescriptionModalWrapperComponent,
  DragDropAreaComponent,
  MobileHeaderComponent,
  MobileFooterComponent,
  EmptyListComponent,
  FileValueAccessorDirective,
  FormlyCardWrapperComponent,
  FormlyEquipmentItemBrowserWrapperComponent,
  FormlyFieldArrayComponent,
  FormlyFieldButtonComponent,
  FormlyFieldCKEditorComponent,
  FormlyFieldTiptapComponent,
  TiptapGalleryImageSelectorComponent,
  FormlyFieldChunkedFileComponent,
  FormlyFieldEquipmentItemBrowserComponent,
  FormlyFieldFileComponent,
  FormlyFieldGoogleMapComponent,
  FormlyFieldImageCropperComponent,
  FormlyFieldNgSelectComponent,
  FormlyFieldStepperComponent,
  FormlyFieldTableComponent,
  FormlyFieldTagsWithAiComponent,
  FormlyFieldTitleWithAiComponent,
  FormlyFieldToggleComponent,
  FormlyFieldTurnstileComponent,
  FormlyFieldCustomNumberComponent,
  FormlyFieldCustomRadioComponent,
  FormlyFieldSliderComponent,
  FormlyFieldColorPickerComponent,
  FormlyWrapperComponent,
  ProgressiveDisclosureGroupSelectComponent,
  ForumPreviewComponent,
  FloatingPresentationButtonComponent,
  FullscreenImageViewerComponent,
  HrComponent,
  ImageComponent,
  ImageHoverComponent,
  ImageIconsComponent,
  ImageGalleryLoadingComponent,
  ImageLoadingIndicatorComponent,
  ImageSearchCardComponent,
  ImageSearchComponent,
  ImageSearchItemListingMessagePipe,
  ImageSearchBrandListingMessagePipe,
  ImageViewerSlideshowComponent,
  ImageViewerSlideshowContextComponent,
  ImageViewerComponent,
  ImageViewerMenuComponent,
  ImageViewerCustomMessageBannerComponent,
  ImageViewerWipBannerComponent,
  ImageViewerTitleComponent,
  ImageViewerFloatingTitleComponent,
  ImageViewerPhotographersComponent,
  ImageViewerSocialButtonsComponent,
  ImageViewerShareButtonComponent,
  ImageViewerDataSourceComponent,
  ImageViewerAcquisitionComponent,
  ImageViewerAcquisitionDatesComponent,
  ImageViewerAcquisitionCsvExportComponent,
  ImageViewerAstrometryComponent,
  ImageViewerObjectsComponent,
  ImageViewerEquipmentComponent,
  ImageViewerGuidingEquipmentComponent,
  ImageViewerEquipmentItemsComponent,
  ImageViewerRevisionsComponent,
  ImageViewerRevisionSummaryComponent,
  ImageViewerGroupsAndCollectionsComponent,
  ImageViewerPlateSolvingBannerComponent,
  ImageViewerCloseButtonComponent,
  ImageViewerAdditionalButtonComponent,
  ImageViewerAdjustmentsEditorComponent,
  ImageViewerIotdBannerComponent,
  ImageViewerIotdTpStatsComponent,
  ForumPostSearchComponent,
  NestedCommentSearchComponent,
  InformationDialogComponent,
  LoadingDialogComponent,
  LoadingIndicatorComponent,
  LoginFormComponent,
  LoginModalComponent,
  OtpInputComponent,
  TwoFactorFormComponent,
  SessionTimeoutTimerComponent,
  MasonryLayoutComponent,
  MarketplaceListingCardComponent,
  PostEquipmentHeaderComponent,
  PostQualityIndicatorPillComponent,
  MarketplaceListingCardsComponent,
  MostOftenUsedWithModalComponent,
  NestedCommentComponent,
  NestedCommentsComponent,
  NestedCommentsCountComponent,
  NestedCommentsModalComponent,
  NothingHereComponent,
  NotificationsListComponent,
  PrivateInformationComponent,
  ReadOnlyModeComponent,
  RefreshButtonComponent,
  ReportAbuseModalComponent,
  RemoveAdsDialogComponent,
  ScrollToTopComponent,
  SubscriptionRequiredModalComponent,
  SwipeToRefreshComponent,
  TelescopeComponent,
  TextLoadingIndicatorComponent,
  ToggleButtonComponent,
  TogglePropertyComponent,
  UsernameComponent,
  UserPostQualityIndicatorsComponent,
  UserSearchComponent,

  // Equipment
  AccessoryEditorComponent,
  AssignEditProposalModalComponent,
  AssignItemModalComponent,
  BaseItemEditorComponent,
  BrandEditorCardComponent,
  BrandEditorFormComponent,
  BrandSummaryComponent,
  CameraEditorComponent,
  ConfirmItemCreationModalComponent,
  EquipmentItemDisplayNameComponent,
  EquipmentFollowOptionsComponent,
  EquipmentFollowOptionsModalComponent,
  EquipmentPresetComponent,
  EquipmentPresetEditorComponent,
  EquipmentPresetSummaryComponent,
  FilterEditorComponent,
  ItemBrowserByPropertiesComponent,
  ItemBrowserComponent,
  ItemSummaryComponent,
  ItemUnapprovedInfoModalComponent,
  MarketplaceListingCardComponent,
  MarketplaceListingCardsComponent,
  MostOftenUsedWithModalComponent,
  MountEditorComponent,
  OthersInBrandComponent,
  RemoveRecentlyUsedEquipmentModalComponent,
  SensorEditorComponent,
  SimilarItemsSuggestionComponent,
  SoftwareEditorComponent,
  StockStatusComponent,
  TelescopeEditorComponent,
  TurnstileCaptchaComponent,
  VariantSelectorModalComponent,

  // Icons
  SparklesIconComponent
];

const services = [UsernameService];

@NgModule({
  imports: [modules],
  declarations: components,
  exports: [...components, TutorialModule, PresentationModeModule, LightboxModule],
  providers: [...services]
})
export class ComponentsModule {
  constructor(public readonly modalConfig: NgbModalConfig) {
    modalConfig.centered = true;
  }
}
